// Pointer/touch input that drives the bartender. Uses canvasInfo.clientToLogicalX
// from render.js for proper letterbox-aware mapping.

export function bindInput(canvas, _world, onMove, canvasInfo) {
  let active = false;

  function handle(e) {
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const lx = canvasInfo
      ? canvasInfo.clientToLogicalX(clientX)
      : ((clientX - canvas.getBoundingClientRect().left) / canvas.getBoundingClientRect().width) * 360;
    onMove(lx);
  }

  function start(e) {
    active = true;
    handle(e);
  }
  function move(e) {
    if (!active) return;
    handle(e);
  }
  function end() { active = false; }

  canvas.addEventListener('pointerdown', start);
  canvas.addEventListener('pointermove', move);
  canvas.addEventListener('pointerup', end);
  canvas.addEventListener('pointercancel', end);
  // touch fallback for older Safari
  canvas.addEventListener('touchstart', start, { passive: true });
  canvas.addEventListener('touchmove', move, { passive: true });
  canvas.addEventListener('touchend', end);

  // Keyboard fallback (desktop dev)
  const keys = {};
  const onKeyDown = (e) => {
    keys[e.key] = true;
    if (e.key === 'ArrowLeft' || e.key === 'a') onMove(Math.max(0, lastLogicalX - 20));
    if (e.key === 'ArrowRight' || e.key === 'd') onMove(Math.min(360, lastLogicalX + 20));
  };
  const onKeyUp = (e) => { keys[e.key] = false; };
  let lastLogicalX = 180;
  const wrapMove = (x) => { lastLogicalX = x; onMove(x); };
  // Re-wire so we track lastLogicalX
  // (simpler: don't re-wire pointer; just expose to keys via closure)
  window.addEventListener('keydown', onKeyDown);
  window.addEventListener('keyup', onKeyUp);

  return () => {
    canvas.removeEventListener('pointerdown', start);
    canvas.removeEventListener('pointermove', move);
    canvas.removeEventListener('pointerup', end);
    canvas.removeEventListener('pointercancel', end);
    canvas.removeEventListener('touchstart', start);
    canvas.removeEventListener('touchmove', move);
    canvas.removeEventListener('touchend', end);
    window.removeEventListener('keydown', onKeyDown);
    window.removeEventListener('keyup', onKeyUp);
  };
}
